import 'css-chunksrc/client/pages/projectPage/timeSheetPage/tutorial/styles.scss';export default {
  "tutorial": "_tutorial_1zms4_1",
  "background": "_background_1zms4_9",
  "main": "_main_1zms4_13",
  "title": "_title_1zms4_23",
  "message": "_message_1zms4_29",
  "action": "_action_1zms4_35",
  "wbs": "_wbs_1zms4_39"
};